import { Injectable } from '@angular/core';

import { StudioTemplateConfigCategory } from '../models/studio-template-model';

import { MediasPublicConstants } from '@features/products/medias';
import { ImageType, ProductViewConfig, ProductViewPlaceValue } from '@shared/product/models';

@Injectable()
export class StudioTemplateConfigurations {
    public getConfig(config: StudioTemplateConfigCategory): Record<string, ProductViewConfig> {
        return {
            N1C: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                imageType: ImageType.double,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                showDescription: config?.showDescription,
                showDetails: config?.showDetails,
                showPrice: config?.showPrice,
                showQuicklyMobile: true,
                media: {
                    widthVW: '100vw',
                    ratio: '3-2',
                },
                showMediaCarousel: false,
                showMediaCarouselMobile: false,
            },
            N1F: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                imageType: ImageType.double,
                location: MediasPublicConstants.PublicMediaLocationType.mobile,
                showDescription: config?.showDescription,
                showDetails: config?.showDetails,
                showPrice: config?.showPrice,
                showQuicklyMobile: true,
                media: {
                    widthVW: '100vw',
                    ratio: '3-2',
                },
                showMediaCarousel: false,
                showMediaCarouselMobile: true,
            },
            N1A: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationType.mobile,
                showDescription: config?.showDescription,
                showDetails: config?.showDetails,
                showPrice: config?.showPrice,
                showQuicklyMobile: true,
                media: {
                    widthVW: '100vw',
                    ratio: '3-4',
                },
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N1J: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                imageType: ImageType.double,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                showDescription: config?.showDescription,
                showDetails: config?.showDetails,
                showPrice: config?.showPrice,
                showQuicklyMobile: true,
                media: {
                    widthVW: '100vw',
                    ratio: '3-2',
                },
                showMediaCarousel: false,
                showMediaCarouselMobile: false,
            },
            N1B: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                imageType: ImageType.double,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                showDescription: config?.showDescription,
                showDetails: config?.showDetails,
                showPrice: config?.showPrice,
                showQuicklyMobile: true,
                media: {
                    widthVW: '100vw',
                    ratio: '3-4',
                },
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N1D: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                imageType: ImageType.double,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                showDescription: config?.showDescription,
                showDetails: config?.showDetails,
                showPrice: config?.showPrice,
                showQuicklyMobile: true,
                media: {
                    widthVW: '100vw',
                    ratio: '3-2',
                },
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N2E: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                showDescription: config?.showDescription,
                showDetails: config?.showDetails,
                showPrice: config?.showPrice,
                showQuicklyMobile: true,
                media: {
                    widthVW: '(max-width: 767px) 50vw, 40vw',
                    ratio: '3-4',
                },
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N2H: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationTypeValues[0],
                showDescription: config?.showDescription,
                showDetails: config?.showDetails,
                showPrice: config?.showPrice,
                showQuicklyMobile: true,
                media: {
                    widthVW: '50vw',
                    ratio: '3-4',
                },
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N4A: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                showDescription: false,
                showDetails: config?.showDetails,
                showPrice: config?.showPrice,
                showQuicklyMobile: true,
                media: {
                    widthVW: '(max-width: 767px) 20vw, 40vw',
                    ratio: '3-4',
                },
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N3D: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                showDescription: false,
                showDetails: true,
                showPrice: true,
                showTags: false,
                showDiscount: false,
                showPromotions: false,
                media: {
                    widthVW: '35vw',
                    ratio: '3-4',
                },
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N2G: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showColors: true,
                showQuicklyMobile: true,
                media: {
                    widthVW: '(max-width: 767px) 100vw, 50vw',
                    ratio: '3-4',
                },
                showDiscount: true,
                showMadeInExclusive: true,
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N3G: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showColors: true,
                showQuicklyMobile: true,
                media: {
                    widthVW: '(max-width: 767px) 100vw, 40vw',
                    ratio: '3-4',
                },
                showDiscount: true,
                showMadeInExclusive: true,
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N3H: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                imageType: undefined,
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showColors: true,
                showQuicklyMobile: true,
                media: {
                    widthVW: '(max-width: 767px) 100vw, 40vw',
                    ratio: '3-4',
                },
                showDiscount: true,
                showMadeInExclusive: true,
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N3J: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationTypeValues[0],
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showColors: true,
                showQuicklyMobile: true,
                media: {
                    widthVW: '(max-width: 767px) 100vw, 40vw',
                    ratio: '3-4',
                },
                showDiscount: true,
                showMadeInExclusive: true,
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N3L: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationTypeValues[0],
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showColors: true,
                showQuicklyMobile: true,
                media: {
                    widthVW: '(max-width: 767px) 100vw, 40vw',
                    ratio: '3-4',
                },
                showDiscount: true,
                showMadeInExclusive: true,
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N3K: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationTypeValues[0],
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showColors: true,
                showQuicklyMobile: true,
                media: {
                    widthVW: '(max-width: 767px) 100vw, 40vw',
                    ratio: '3-4',
                },
                showDiscount: true,
                showMadeInExclusive: true,
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N3F: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                showDescription: false,
                showDetails: true,
                showPrice: true,
                showTags: false,
                showDiscount: false,
                showPromotions: false,
                showQuicklyMobile: true,
                media: {
                    widthVW: '(max-width: 767px) 35vw, 25vw',
                    ratio: '3-4',
                },
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N3M: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationTypeValues[0],
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showColors: true,
                showQuicklyMobile: true,
                media: {
                    widthVW: '(max-width: 767px) 100vw, 40vw',
                    ratio: '3-4',
                },
                showDiscount: true,
                showMadeInExclusive: true,
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N3N: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationTypeValues[0],
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showColors: true,
                showQuicklyMobile: true,
                media: {
                    widthVW: '(max-width: 767px) 100vw, 40vw',
                    ratio: '3-4',
                },
                showDiscount: true,
                showMadeInExclusive: true,
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N3P: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationTypeValues[0],
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showColors: true,
                showQuicklyMobile: true,
                media: {
                    widthVW: '(max-width: 767px) 100vw, 40vw',
                    ratio: '3-4',
                },
                showDiscount: true,
                showMadeInExclusive: true,
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N4G: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                media: {
                    widthVW: '(max-width: 767px) 50vw, 25vw',
                    ratio: '3-4',
                },
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N4J: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showColors: true,
                showQuicklyMobile: true,
                media: {
                    widthVW: '(max-width: 767px) 100vw, 30vw',
                    ratio: '3-4',
                },
                showDiscount: true,
                showMadeInExclusive: true,
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N4H: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showColors: true,
                showQuicklyMobile: true,
                media: {
                    widthVW: '(max-width: 767px) 100vw, 30vw',
                    ratio: '3-4',
                },
                showDiscount: true,
                showMadeInExclusive: true,
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N4K: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showColors: true,
                showQuicklyMobile: true,
                media: {
                    widthVW: '30vw',
                    ratio: '3-4',
                },
                showDiscount: true,
                showMadeInExclusive: true,
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N4L: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showColors: true,
                showQuicklyMobile: true,
                media: {
                    widthVW: '30vw',
                    ratio: '3-4',
                },
                showDiscount: true,
                showMadeInExclusive: true,
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N4M: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showColors: true,
                showQuicklyMobile: true,
                media: {
                    widthVW: '30vw',
                    ratio: '3-4',
                },
                showDiscount: true,
                showMadeInExclusive: true,
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            N4N: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showColors: true,
                showQuicklyMobile: true,
                media: {
                    widthVW: '30vw',
                    ratio: '3-4',
                },
                showDiscount: true,
                showMadeInExclusive: true,
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
            NSLA: {
                clickable: true,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                place: ProductViewPlaceValue.PRODUCT_GRID,
                imageType: ImageType.double,
                showQuicklyMobile: true,
                media: {
                    ratio: '3-4',
                    widthVW: '100vw',
                },
                showSecondImageIfPossible: true,
                showMediaCarousel: false,
                showMediaCarouselMobile: false,
            },
            NSLB: {
                clickable: true,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                place: ProductViewPlaceValue.PRODUCT_GRID,
                imageType: ImageType.double,
                showQuicklyMobile: true,
                media: {
                    ratio: '3-4',
                    widthVW: '100vw',
                },
                showSecondImageIfPossible: true,
                showMediaCarousel: false,
                showMediaCarouselMobile: false,
            },
            Monox3: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: undefined, // Importante en este tipo de template no filtrar por location
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showColors: true,
                showQuicklyMobile: true,
                media: {
                    widthVW: '(max-width: 767px) 100vw, 40vw',
                    ratio: '3-4',
                },
                showDiscount: true,
                showMadeInExclusive: true,
                multipleMedias: 3,
                showMediaCarousel: false,
                showMediaCarouselMobile: false,
            },
            Monox4: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: undefined, // Importante en este tipo de template no filtrar por location
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showColors: true,
                showQuicklyMobile: true,
                media: {
                    widthVW: '(max-width: 767px) 100vw, 30vw',
                    ratio: '3-4',
                },
                showDiscount: true,
                showMadeInExclusive: true,
                multipleMedias: 4,
                showMediaCarousel: false,
                showMediaCarouselMobile: false,
            },
            default: {
                place: ProductViewPlaceValue.PRODUCT_GRID,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                showDetails: config?.showDetails,
                showPrice: config?.showPrice,
                showQuicklyMobile: true,
                media: {
                    widthVW: '100vw',
                    ratio: '3-4',
                },
                showMediaCarousel: true,
                showMediaCarouselMobile: true,
            },
        };
    }

    public getStudioTemplateConfig(templateName: string, config?: StudioTemplateConfigCategory): ProductViewConfig {
        const templatesConfig = this.getConfig(config);
        return templatesConfig[templateName] ? templatesConfig[templateName] : templatesConfig.default;
    }
}
